<ng-container [formGroup]="currentForm" *ngIf="!isMobileDeviceSize;else mobileForm">
  <div id="basic-info" class="grid-gap" [ngClass]="{ 'invisible' : !showBasicInfoPanel }">
    <app-instructions></app-instructions>

    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Basic Information
      </p>
    </div>
    <app-suggested-names [substanceType]="SubstanceType.ContactLensMaterial"></app-suggested-names>
    <app-chemical-names [substanceType]="SubstanceType.None" [shouldShowFullTitle]="false"></app-chemical-names>
    <app-polymer-presence-disclosure></app-polymer-presence-disclosure>
    <app-semi-interpenetrating-network-disclosure></app-semi-interpenetrating-network-disclosure>
    <app-degree-of-polymerization></app-degree-of-polymerization>
    
    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showMolecularInfoPanel'" [displaySectionName]="'molecular information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="molecular-info" class="grid-gap" [ngClass]="{ 'invisible' : !showMolecularInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Molecular Information
      </p>
    </div>
    <app-molecular-info></app-molecular-info>
    <app-molecular-formula [substanceType]="SubstanceType.ContactLensMaterial" [shouldShowFullTitle]="false"></app-molecular-formula>
    <app-chemicals-attached></app-chemicals-attached>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showSubstanceDetailsPanel'" [displaySectionName]="'substance details'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="substance-details" class="grid-gap" [ngClass]="{ 'invisible' : !showSubstanceDetailsPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Substance Details
      </p>
    </div>
    <app-manufacturing-process></app-manufacturing-process>
    <app-cas-registry [substanceType]="SubstanceType.ContactLensMaterial" [shouldShowFullTitle]="false"></app-cas-registry>
    <app-purity-of-2-hydroxyethyl-methacrylate></app-purity-of-2-hydroxyethyl-methacrylate>
    <app-water-content></app-water-content>
    <app-oxygen-permeability></app-oxygen-permeability>
    <app-trademarks></app-trademarks>
    
    
    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showManufactureUsageInfoPanel'" [displaySectionName]="'manufacturer and usage info'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="manufacture-usage-info" class="grid-gap" [ngClass]="{ 'invisible' : !showManufactureUsageInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Manufacturer and Usage Information
      </p>
    </div>
    <app-manufacturers [includesAddress]="false"></app-manufacturers>
    
    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showClinicalTrialInfoPanel'" [displaySectionName]="'clinical trial information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="clinical-trial-info" class="grid-gap" [ngClass]="{ 'invisible' : !showClinicalTrialInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Clinical Trial Information
      </p>
    </div>
    <app-phase-one-trial-date></app-phase-one-trial-date>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showUploadDocumentsPanel'" [displaySectionName]="'upload documents'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="upload-documents" class="grid-gap" [ngClass]="{ 'invisible' : !showUploadDocumentsPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Upload Documents
      </p>
    </div>
    <upload-documents-instructions></upload-documents-instructions>
    <app-absence-of-conflict></app-absence-of-conflict>
   <!-- <app-trademark-search-results></app-trademark-search-results> -->
    <app-structural-formula [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="false"></app-structural-formula>
    <app-cas-registry-info></app-cas-registry-info>
    <app-cover-letter></app-cover-letter>
    <app-statement-of-adoption></app-statement-of-adoption>

    
       <div class="no-gap">
      <app-form-nav-button [sectionName]="'showApplicantInfoPanel'" [displaySectionName]="'applicant information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="applicant-info" class="grid-gap" [ngClass]="{ 'invisible' : !showApplicantInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Applicant Information
      </p>
    </div>
    <app-applicant-info></app-applicant-info>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showPaymentInfoPanel'" [displaySectionName]="'payment information'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="payment-info" class="grid-gap" [ngClass]="{ 'invisible' : !showPaymentInfoPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Payment Information
      </p>
    </div>
    <app-payment-info></app-payment-info>

    <div class="no-gap">
      <app-form-nav-button [sectionName]="'showTermsAndConditionsPanel'" [displaySectionName]="'terms and conditions'"></app-form-nav-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
  <div id="terms-conditions" class="grid-gap" [ngClass]="{ 'invisible' : !showTermsAndConditionsPanel }">
    <div class="usan-form-item">
      <p class="draft-section-header-typography basic-info-title">
        Terms and Conditions
      </p>
    </div>
    <app-terms-conditions></app-terms-conditions>

    <div class="no-gap">
      <app-agree-submit-button></app-agree-submit-button>
      <app-save-draft-button></app-save-draft-button>
    </div>
  </div>
</ng-container>
<ng-template #mobileForm>
  <div class="usan-form-item">
    <app-instructions></app-instructions>

    <mat-accordion class="stretch panel-gap">
      <mat-expansion-panel (opened)="showBasicInfoPanel = true" (closed)="showBasicInfoPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Basic Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Basic Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-suggested-names [substanceType]="SubstanceType.ContactLensMaterial"></app-suggested-names>
        <app-chemical-names [substanceType]="SubstanceType.None" [shouldShowFullTitle]="false"></app-chemical-names>
        <app-polymer-presence-disclosure></app-polymer-presence-disclosure>
        <app-semi-interpenetrating-network-disclosure></app-semi-interpenetrating-network-disclosure>
        <app-degree-of-polymerization></app-degree-of-polymerization>

        <app-form-nav-button [sectionName]="'showMolecularInfoPanel'" [displaySectionName]="'molecular information'"></app-form-nav-button>
        <app-save-draft-button></app-save-draft-button>

      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showMolecularInfoPanel = true" (closed)="showMolecularInfoPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            <span>Molecular Information</span>
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Molecular Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-molecular-info></app-molecular-info>
        <app-molecular-formula [substanceType]="SubstanceType.ContactLensMaterial" [shouldShowFullTitle]="false"></app-molecular-formula>
        <app-chemicals-attached></app-chemicals-attached>

        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showSubstanceDetailsPanel = true" (closed)="showSubstanceDetailsPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            <span>Substance Details</span>
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Substance Details')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-manufacturing-process></app-manufacturing-process>
        <app-cas-registry [substanceType]="SubstanceType.ContactLensMaterial" [shouldShowFullTitle]="false"></app-cas-registry>
        <app-purity-of-2-hydroxyethyl-methacrylate></app-purity-of-2-hydroxyethyl-methacrylate>
        <app-water-content></app-water-content>
        <app-oxygen-permeability></app-oxygen-permeability>
        <app-trademarks></app-trademarks>
        
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showManufactureUsageInfoPanel = true" (closed)="showManufactureUsageInfoPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Manufacturer and Usage Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Manufacturer and Usage Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-manufacturers [includesAddress]="false"></app-manufacturers>

        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showClinicalTrialInfoPanel = true" (closed)="showClinicalTrialInfoPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Clinical Trial Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Clinical Trial Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-phase-one-trial-date></app-phase-one-trial-date>
    
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showUploadDocumentsPanel = true" (closed)="showUploadDocumentsPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Upload Documents
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Upload Documents')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>    
        <upload-documents-instructions></upload-documents-instructions>
        <app-absence-of-conflict></app-absence-of-conflict>
       <!-- <app-trademark-search-results></app-trademark-search-results> -->
        <app-structural-formula [substanceType]="SubstanceType.SingleEntity" [shouldShowFullTitle]="false"></app-structural-formula>
        <app-cas-registry-info></app-cas-registry-info>
        <app-cover-letter></app-cover-letter>
        <app-statement-of-adoption></app-statement-of-adoption>
        
        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>    

      <mat-expansion-panel (opened)="showApplicantInfoPanel = true" (closed)="showApplicantInfoPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Applicant Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Applicant Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-applicant-info></app-applicant-info>

        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>
      
      <mat-expansion-panel (opened)="showPaymentInfoPanel = true" (closed)="showPaymentInfoPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">
            Payment Information
            <mat-icon class="input-error" [ngClass]="{ 'invisible' : !sectionHasError('Payment Information')}" >warning</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-payment-info></app-payment-info>

        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="showTermsAndConditionsPanel = true" (closed)="showTermsAndConditionsPanel = false">
        <mat-expansion-panel-header>
          <mat-panel-title class="mobile-section-title">Terms and Conditions</mat-panel-title>
        </mat-expansion-panel-header>
        <app-terms-conditions></app-terms-conditions>
        <app-agree-submit-button></app-agree-submit-button>

        <app-save-draft-button></app-save-draft-button>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</ng-template>